<template>
    <div class="FamilyStatusEditor">
        <h2>Family Status History</h2>
        <!--DISPLAY TABLE-->
        <b-container fluid>
            <b-row style="overflow-x:auto;">
                <b-col cols="11">
                    <vuetable :fields="TableFields"
                              :data="TableData"
                              pagination-path=""
                              :api-mode="false"
                              class="vue-datatable"
                              row-class="bold-first-row">

                        <template slot="DetailView" scope="props">
                            <div class="DetailView">
                                <span class="underline pointer" @click="ShowDetailView(props.rowData)"><span v-html="props.rowData.Name"></span> <font-awesome-icon :icon="['fa', 'edit']" v-if="EditMode" /></span>
                            </div>
                        </template>
                    </vuetable>
                </b-col>
                <b-col cols="1">
                    <div v-if="EditMode" class="vert-icons">
                        <b-row>
                            <font-awesome-icon :icon="['fa', 'plus']" v-on:click="ShowAddEditSchool()" class="pointer olive-green-text" />
                        </b-row>
                    </div>
                </b-col>
            </b-row>
        </b-container>

        <!--ADD AND EDIT AND DETAIL MODAL-->
        <b-modal ref="modal-school" size="lg" :title="ModalSchoolTitle" hide-footer no-close-on-esc no-close-on-backdrop>
            <b-container v-if="EditMode == false && TargetSchool.Id">
                <b-row>
                    <b-col>
                        <h3>Status Info</h3>
                        <p><span class="bold">Name: </span>{{TargetSchool.Name}}</p>
                        <p><span class="bold">Specifier: </span>{{TargetSchool.Specifier}}</p>
                    </b-col>
                    <b-col>
                        <h3>Details:</h3>
                        <p><span class="bold">Notes: </span>{{TargetSchool.Specifier}}</p>
                        <p><span class="bold">Effective Date: </span>{{ formatDate(TargetSchool.StartDate,'MM/DD/YY') }}</p>
                    </b-col>
                </b-row>
                <b-row class="modal-btn-row">
                    <div class="modal-btn-row-div">
                        <b-button size="md" variant="secondary" @click="CancelSchool()">
                            CLOSE
                        </b-button>
                    </div>
                </b-row>
            </b-container>
            <b-container v-if="EditMode">
                <b-form @submit="AddEditSchool" autocomplete="off">
                    <b-row>
                        <b-col>
                            <h3>Status Info</h3>
                            <div class="form-group">
                                <label>Status Name:</label>
                                <select type="text" required class="form-control" v-model="TargetSchool.Name" :disabled="TargetSchool.Id">
                                    <option value="Inquiry">Inquiry</option>
                                    <option value="Applicant">Applicant</option>
                                    <option value="Active">Active</option>
                                    <option v-if="!IsPNW" value="Temporarily Inactive">Temporarily Inactive</option>
                                    <option value="Archived">Archived</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Optional Specifier:</label>
                                <select type="text" class="form-control" required v-model="TargetSchool.Specifier">
                                    <option v-if="TargetSchool.Name != 'Archived'" value="NONE">NONE</option>
                                    <option v-if="TargetSchool.Name == 'Inquiry'" value="Referral: Church">Referral: Church</option>
                                    <option v-if="TargetSchool.Name == 'Inquiry'" value="Referral: KFSH">Referral: KFSH</option>
                                    <option v-if="TargetSchool.Name == 'Inquiry'" value="Referral: KWVE">Referral: KWVE</option>
                                    <option v-if="TargetSchool.Name == 'Inquiry'" value="Referral: Christian Examiner">Referral: Christian Examiner</option>
                                    <option v-if="TargetSchool.Name == 'Inquiry'" value="Referral: Christian Business Directory">Referral: Christian Business Directory</option>
                                    <option v-if="TargetSchool.Name == 'Inquiry'" value="Referral: Angels in Waiting">Referral: Angels in Waiting</option>
                                    <option v-if="TargetSchool.Name == 'Inquiry'" value="Referral: Olive Crest Foster Family">Referral: Olive Crest Foster Family</option>
                                    <option v-if="TargetSchool.Name == 'Inquiry'" value="Referral: Olive Crest Staff">Referral: Olive Crest Staff</option>
                                    <option v-if="TargetSchool.Name == 'Inquiry'" value="Referral: Special Event">Referral: Special Event</option>
                                    <option v-if="TargetSchool.Name == 'Inquiry'" value="Referral: CA Kids Connection">Referral: CA Kids Connection</option>
                                    <option v-if="TargetSchool.Name == 'Inquiry'" value="Referral: AdoptUSKids">Referral: AdoptUSKids</option>
                                    <option v-if="TargetSchool.Name == 'Inquiry'" value="Referral: County Social Services">Referral: County Social Services</option>
                                    <option v-if="TargetSchool.Name == 'Inquiry'" value="Referral: Internet Search - Google">Referral: Internet Search - Google</option>
                                    <option v-if="TargetSchool.Name == 'Inquiry'" value="Referral: Internet Search - Bing">Referral: Internet Search - Bing</option>
                                    <option v-if="TargetSchool.Name == 'Inquiry'" value="Referral: Internet Search - Yahoo">Referral: Internet Search - Yahoo</option>
                                    <option v-if="TargetSchool.Name == 'Inquiry'" value="Referral: Internet Search - DuckDuckGo">Referral: Internet Search - DuckDuckGo</option>
                                    <option v-if="TargetSchool.Name == 'Inquiry'" value="Referral: Internet Search - Other">Referral: Internet Search - Other</option>
                                    <option v-if="TargetSchool.Name == 'Inquiry'" value="Referral: Olive Crest Newsletter or Facebook">Referral: Olive Crest Newsletter or Facebook</option>
                                    <option v-if="TargetSchool.Name == 'Inquiry'" value="Referral: Send Conference">Referral: Send Conference</option>
                                    <option v-if="TargetSchool.Name == 'Inquiry'" value="Referral: Other">Referral: Other (see notes)</option>
                                    <!--ACTIVE SPECIFIERS-->
                                    <option v-if="TargetSchool.Name == 'Active'" value="Placement Hold">Placement Hold</option>
                                    <option v-if="TargetSchool.Name == 'Active'" value="Suspended">Suspended</option>
                                    <!--Temporary Inactive SPECIFIERS-->
                                    <option v-if="TargetSchool.Name == 'Temporarily Inactive'" value="Inactive Status">Inactive Status (CA 2 Year Max)</option>
                                    <!--CLOSED SPECIFIERS-->
                                    <optgroup v-if="TargetSchool.Name == 'Archived'" label="CLOSED BY FAMILY DURING APPLICATION">
                                        <option value="CLOSED BY FAMILY DURING APPLICATION: Rejected Regional Requirements">Rejected Regional Requirements</option>
                                        <option value="CLOSED BY FAMILY DURING APPLICATION: Rejected Board Requirements">Rejected Board Requirements</option>
                                        <option value="CLOSED BY FAMILY DURING APPLICATION: No Response from Family">No Response from Family</option>
                                        <option value="CLOSED BY FAMILY DURING APPLICATION: Family Moved">Family Moved</option>
                                        <option value="CLOSED BY FAMILY DURING APPLICATION: Poor Timing/Family Circumstances">Poor Timing/Family Circumstances</option>
                                        <option value="CLOSED BY FAMILY DURING APPLICATION: Other: Olive Crest Decision">Other: Olive Crest Decision</option>
                                    </optgroup>
                                    <optgroup v-if="TargetSchool.Name == 'Archived'" label="CLOSED BY OLIVE CREST DURING APPLICATION">
                                        <option value="CLOSED BY OLIVE CREST DURING APPLICATION: Violation of Law or Standard">Violation of Law or Standard</option>
                                        <option value="CLOSED BY OLIVE CREST DURING APPLICATION: Reported Unresolved Trauma">Reported Unresolved Trauma</option>
                                        <option value="CLOSED BY OLIVE CREST DURING APPLICATION: Exhibited Disruptive Behavior">Exhibited Disruptive Behavior</option>
                                        <option value="CLOSED BY OLIVE CREST DURING APPLICATION: Exhibited Poor or Irresponsible Behavior">Exhibited Poor or Irresponsible Behavior</option>
                                        <option value="CLOSED BY OLIVE CREST DURING APPLICATION: Undisclosed Arrest/Conviction">Undisclosed Arrest/Conviction</option>
                                        <option value="CLOSED BY OLIVE CREST DURING APPLICATION: Evidence of Poor Financial Stewardship">Evidence of Poor Financial Stewardship</option>
                                        <option value="CLOSED BY OLIVE CREST DURING APPLICATION: Undisclosed Allegation/Investigation">Undisclosed Allegation/Investigation</option>
                                        <option value="CLOSED BY OLIVE CREST DURING APPLICATION: Failure to Pass Background Check">Failure to Pass Background Check</option>
                                        <option value="CLOSED BY OLIVE CREST DURING APPLICATION: Unable to Secure Medical Release">Unable to Secure Medical Release</option>
                                        <option value="CLOSED BY OLIVE CREST DURING APPLICATION: Unable to Secure Therapeutic Release">Unable to Secure Therapeutic Release</option>
                                        <option value="CLOSED BY OLIVE CREST DURING APPLICATION: Poor Reference Feedback">Poor Reference Feedback</option>
                                        <option value="CLOSED BY OLIVE CREST DURING APPLICATION: Other: Olive Crest Decision">Other: Olive Crest Decision</option>
                                    </optgroup>
                                    <optgroup v-if="TargetSchool.Name == 'Archived'" label="APPROVAL/LICENSE RESCINDED BY OLIVE CREST">
                                        <option value="APPROVAL/LICENSE RESCINDED BY OLIVE CREST: Decision by CCL">Decision by CCL</option>
                                        <option value="APPROVAL/LICENSE RESCINDED BY OLIVE CREST: Violation of Law or Standard">Violation of Law or Standard</option>
                                        <option value="APPROVAL/LICENSE RESCINDED BY OLIVE CREST: Exhibited Disruptive Behavior">Exhibited Disruptive Behavior</option>
                                        <option value="APPROVAL/LICENSE RESCINDED BY OLIVE CREST: Exhibited Poor or Irresponsible Behavior">Exhibited Poor or Irresponsible Behavior</option>
                                        <option value="APPROVAL/LICENSE RESCINDED BY OLIVE CREST: Other: Olive Crest Decision">Other: Olive Crest Decision</option>
                                    </optgroup>
                                    <optgroup v-if="TargetSchool.Name == 'Archived'" label="APPROVAL/LICENSE FORFEITED BY FAMILY">
                                        <option value="APPROVAL/LICENSE FORFEITED BY FAMILY: Family Ported to Another Agency">Family Ported to Another Agency</option>
                                        <option value="APPROVAL/LICENSE FORFEITED BY FAMILY: Family Moved">Family Moved</option>
                                        <option value="APPROVAL/LICENSE FORFEITED BY FAMILY: No Desire to Return from Temporary Inactive">No Desire to Return from Temporary Inactive</option>
                                        <option value="APPROVAL/LICENSE FORFEITED BY FAMILY: Adoption Completed and no Desire to Continue Fostering">Adoption Completed and no Desire to Continue Fostering</option>
                                        <option value="APPROVAL/LICENSE FORFEITED BY FAMILY: Death in Family">Death in Family</option>
                                        <option value="APPROVAL/LICENSE FORFEITED BY FAMILY: Unable/Unwilling to comply with Requirements">Unable/Unwilling to comply with Requirements</option>
                                        <option value="APPROVAL/LICENSE FORFEITED BY FAMILY: Family Choice - Unspecified">Family Choice - Unspecified</option>
                                    </optgroup>
                                </select>
                            </div>
                        </b-col>
                        <b-col>
                            <h3>Details</h3>
                            <div class="form-group">
                                <label>Notes:</label>
                                <textarea v-model="TargetSchool.Notes" class="form-control" rows="4"></textarea>
                            </div>
                            <div class="form-group">
                                <label>Effective Date:</label>
                                <flat-pickr v-model="TargetSchool.StartDate" class="form-control" required :config="DateConfig"></flat-pickr>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelSchool()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit" v-if="EditMode">
                                SAVE
                            </b-button>
                            <b-button size="md" variant="danger" @click="DeleteSchool()" type="button" v-if="TargetSchool.Id">
                                DELETE
                            </b-button>
                        </div>
                </b-form>
            </b-container>
        </b-modal>
    </div>

</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faTrashAlt);
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    import Vuetable from 'vuetable-2/src/components/Vuetable';
    import { EventBus } from '../../../../services/event-bus.js';

    export default {
        props: [
            "EditMode",//bool
            "GlobalUpdate",//bool
            "ChartId",
            "SubProgramId"
        ],
        data: function () {
            return {
                TargetSchool: {},
                CommonSchoolSelection: "",
                ModalSchoolTitle: "",
                LoadedRecords: [],//Contact Membership Records
                SchoolSchema: {
                    StartDate: "",
                    Name: "",
                    Specifier: "",
                    Notes: "",
                    FosterResourceFamilyID: ""
                },
                DateConfig: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y',
                    required: false
                }

            };
        },
        methods: {
            onRowClass(dataItem, index) {
                return (dataItem.EndDate == null) ? 'current-record' : '';
            },
            GetSchools() {
                this.$MasterAPI.ExecuteRequest("GET", "Foster/FamilyStatus/GetFamilyStatuses", { FosterResourceFamilyID: this.ChartId }, this.GetSchoolsSuccess, () => { }, false);
            },
            GetSchoolsSuccess(response) {
                this.LoadedRecords = response.data.data;
            },
            ShowDetailView(school) {
                this.TargetSchool = JSON.parse(JSON.stringify(school));

                if (this.EditMode) {
                    this.ModalSchoolTitle = "Editing Status ";
                } else {
                    this.ModalSchoolTitle = "Viewing Status";
                }
                this.$refs["modal-school"].show();
            },
            ShowAddEditSchool() {
                this.TargetSchool = JSON.parse(JSON.stringify(this.SchoolSchema));
                this.ModalSchoolTitle = "Add New Status";
                this.$refs["modal-school"].show();
            },
            AddEditSchool(e) {
                e.preventDefault();
                this.TargetSchool.FosterResourceFamilyID = this.ChartId;
                this.$MasterAPI.ExecuteRequest("POST", "Foster/FamilyStatus/AddEditStatus", this.TargetSchool, this.AddEditSchoolSuccess, () => { }, true);
            },
            AddEditSchoolSuccess(reponse) {
                this.GetSchools();
                this.$refs["modal-school"].hide();
            },
            DeleteSchool() {
                this.$MasterAPI.ExecuteRequest("POST", "Foster/FamilyStatus/DeleteStatus", { Id: this.TargetSchool.Id }, this.DeleteSchoolSuccess, () => { }, true);
            },
            DeleteSchoolSuccess(response) {
                this.GetSchools();
                this.$refs["modal-school"].hide();
            },
            CancelSchool() {
                this.$refs['modal-school'].hide();
            },
            formatDate(value, fmt = 'D MMM YYYY') {
                return (value == null || value == '')
                    ? ''
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            }
        },
        components: {
            flatPickr,
            Vuetable
        },
        computed: {
            TableFields: function () {
                let vm = this;
                let fieldData = [
                    {
                        name: "__slot:DetailView",
                        title: "NAME"
                    },
                    {
                        name: "Specifier",
                        title: "SPECIFIER"
                    },
                    {
                        name: "Notes",
                        title: "NOTES"
                    },
                    {
                        name: "StartDate",
                        title: "DATE",
                        callback: 'formatDate|MM/DD/YY',
                    }
                ];
                return fieldData;
            },
            TableData: function () {
                return this.LoadedRecords;
            },
            IsPNW: function () {
                if (this.$store.state.Options.PNWSubPrograms.includes(this.SubProgramId.toUpperCase())) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        mounted() {
            this.GetSchools();
            this.TargetSchool = this.SchoolSchema;
        }
    }
</script>

<style scoped>
    .vert-icons div {
        margin-top: 10px;
    }

    /deep/ tbody tr:first-child {
        font-weight: bold;
    }

    table {
        table-layout: auto;
    }

    .vue-datatable {
        width: 100%;
        display: inline-table;
        overflow-x: auto;
    }
</style>